export default "__VITE_ASSET__aW3fOrFY__"